export const ENTRA = "E";
export const SALE = "S";
  